module.exports = __webpack_public_path__ + "static/media/CarryOn_HandLaggage_Arrows Gray.b0bb6b6c.glb";